import { PlatformShortcode } from '@/utils/convert-platform'

export const shouldShowContentDistribution = (
  platformShortcode: PlatformShortcode,
): boolean => {
  return ![PlatformShortcode.TikTok, PlatformShortcode.Twitter].includes(
    platformShortcode,
  )
}
